export const homeRoutes = [
	{
		path: "/home/periodical",
		name: "HomePeriodical",
		component: () => import("@/home/Periodical.vue"),
		meta:{
			title:'医学期刊'
		}
	},
	{
		path: "/home/gens",
		name: "HomeGens",
		component: () => import("@/home/Gens.vue"),
		meta:{
			title:'生信分析'
		}
	},
	{
		path: "/home/video",
		name: "VideoTest",
		component: () => import("@/home/Video.vue"),
	},
];
